<template>
    <div>
        <v-card style="" class="py-3 px-2 voicemails">
            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <div v-if="!loading">
                <v-card class="pa-2 pl-3 pb-3">
                    <div v-if="!editing">
                        <v-btn
                            small
                            color="success"
                            class="mt-2 mb-2"
                            @click="editSettings"
                            >{{
                                filterList.length
                                    ? "Edit Settings"
                                    : "Add Settings"
                            }}</v-btn
                        >
                        <v-layout row class="pt-2 px-3 mb-3">
                            <div class="font-weight-medium mr-2">
                                Blocked:
                            </div>
                            <div>
                                {{ student.isBlocked ? "Yes" : "No" }}
                            </div>
                        </v-layout>
                        <div v-for="(filter, index) in filterList">
                            <v-layout row class="pt-3 pb-2 px-3">
                                <div class="width-250">
                                    {{ filter.number | phone }}
                                </div>
                                <div class="width-250 font-weight-regular">
                                    {{ filter.type }}
                                </div>
                            </v-layout>
                            <v-divider
                                class="mb-2"
                                v-if="index + 1 < filterList.length"
                            ></v-divider>
                        </div>
                    </div>
                    <div v-if="editing">
                        <v-switch
                            color="success"
                            class="my-3 pb-3 ml-2"
                            v-model="student.isBlocked"
                            label="Blocked"
                            hide-details
                        ></v-switch>

                        <v-layout
                            row
                            class="px-3"
                            style="width: 500px"
                            v-for="(filter, index) in filterList"
                        >
                            <v-text-field
                                class="px-1 mr-2 pt-0 mt-0"
                                label="Number"
                                v-model="filter.number"
                                ref="number"
                                :rules="[rules.phoneNumber]"
                            ></v-text-field>
                            <v-select
                                label="Type"
                                class="px-1 mx-2 pt-0 mt-0"
                                v-model="filter.type"
                                :items="['BLOCK', 'ALLOW']"
                            ></v-select>
                            <v-btn
                                class="pt-0 mt-0"
                                @click="addNumber"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn
                                class="pt-0 mt-0"
                                @click="removeNumber(index)"
                                flat
                                icon
                                color="#f55a4e"
                            >
                                <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                        </v-layout>
                        <div style="width: 458px;">
                            <v-card-actions class="mr-0">
                                <v-spacer></v-spacer>
                                <v-btn
                                    small
                                    color="default"
                                    dark
                                    @click="rollbackSettings"
                                    >Cancel</v-btn
                                >
                                <v-btn
                                    small
                                    :loading="processing"
                                    color="success"
                                    @click="saveSettings"
                                    >Save</v-btn
                                >
                            </v-card-actions>
                        </div>
                    </div>
                </v-card>
            </div>
        </v-card>
    </div>
</template>
<script>
import moment from "moment";

export default {
    props: {
        studentID: String,
        student: Object,
    },
    data() {
        return {
            loading: true,
            filterList: [],

            editing: false,
            processing: false,

            rules: {
                required: (value) => !!value || "Required.",
                phoneNumber: (v) => {
                    return (
                        !v ||
                        ([10, 11].includes(v.replace(/-/g, "").length) &&
                            /^\d+$/.test(v.replace(/-/g, ""))) ||
                        "Invalid Phone Number"
                    );
                },
            },
        };
    },
    watch: {},
    async created() {
        await this.loadFilterList();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        async loadFilterList() {
            const filterList = await this.$http.get(
                "api/campStudents/getFilterList?studentID=" +
                    this.$route.params.id
            );

            this.filterList = filterList;
            this.loading = false;
        },
        editSettings() {
            this.editing = true;

            if (!this.filterList.length) {
                this.addNumber();
            }
        },
        rollbackSettings() {
            this.editing = false;

            this.loadFilterList();
        },
        validate() {
            return this.filterList.every((n, i) =>
                this.$refs.number[i].validate(true)
            );
        },
        async saveSettings() {
            if (!this.validate()) return;

            try {
                this.processing = true;

                await this.$http.post("api/campStudents/saveFilterSettings", {
                    studentID: this.studentID,
                    isBlocked: this.student.isBlocked ? true : false,
                    filter: this.filterList
                        .filter((f) => f.number)
                        .map((f) => ({
                            number:
                                f.number.length == 11
                                    ? f.number.substr(-10)
                                    : f.number,
                            type: f.type,
                        })),
                });

                this.processing = false;
                this.editing = false;

                this.loadFilterList();
            } catch (e) {
                this.processing = false;
            }
        },
        getListCount() {
            return this.filterList.length;
        },
        addNumber() {
            this.filterList.push({
                number: "",
                type: "BLOCK",
            });

            this.$forceUpdate();
        },
        removeNumber(index) {
            if (this.filterList.length == 1) {
                this.filterList[0].number == "";

                return;
            }

            this.filterList.splice(index, 1);

            this.$forceUpdate();
        },
    },
};
</script>
<style>
.voicemails {
    background-color: #f1ffdc !important;
    /*height: 350px;
    overflow-y: auto;*/
}
</style>
